/* Moodie Hero - gallery, bundle picker, upsells, add-to-cart with drawer */
(function () {
  'use strict';

  var ANCHOR = 'moodie-setup';

  function scrollToSetup() {
    var target = document.getElementById(ANCHOR);
    if (!target) return false;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    // brief highlight so the user sees where they landed
    target.classList.add('mdh-flash');
    setTimeout(function () { target.classList.remove('mdh-flash'); }, 1400);
    return true;
  }

  function initHero(root) {
    if (!root || root.dataset.mdhInit) return;
    root.dataset.mdhInit = '1';

    // expose the bundle picker as a scroll target for sticky bars / CTAs
    var picker = root.querySelector('.mdh-picker');
    if (picker && !document.getElementById(ANCHOR)) picker.id = ANCHOR;

    var main = root.querySelector('[data-main-img]');
    var strip = root.querySelector('[data-strip]');

    function swap(src, w, h) {
      if (!main || !src) return;
      main.src = src;
      if (w && h) {
        main.setAttribute('width', w);
        main.setAttribute('height', h);
      }
    }

    root.querySelectorAll('.mdh-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.mdh-thumb').forEach(function (x) {
          x.setAttribute('aria-current', 'false');
        });
        t.setAttribute('aria-current', 'true');
        swap(t.dataset.src, t.dataset.w, t.dataset.h);
      });
    });

    root.querySelectorAll('[data-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!strip) return;
        strip.scrollBy({
          left: parseInt(btn.dataset.nav, 10) * strip.clientWidth * 0.75,
          behavior: 'smooth'
        });
      });
    });

    var cards = root.querySelectorAll('.mdh-card');
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.hasAttribute('disabled')) return;
        cards.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        if (c.dataset.img) swap(c.dataset.img, c.dataset.w, c.dataset.h);
      });
    });

    root.querySelectorAll('.mdh-vid video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });

    function selectedVariant() {
      var c = root.querySelector('.mdh-card[aria-pressed="true"]:not([disabled])') ||
              root.querySelector('.mdh-card:not([disabled])');
      return c ? parseInt(c.dataset.vid, 10) : 0;
    }

    function rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    var cta = root.querySelector('[data-atc]');
    if (!cta) return;

    cta.addEventListener('click', function () {
      var vid = selectedVariant();
      if (!vid) { alert('Please choose an option first.'); return; }

      var items = [{ id: vid, quantity: 1 }];
      root.querySelectorAll('.mdh-upcheck:checked').forEach(function (cb) {
        var uv = parseInt(cb.dataset.vid, 10);
        if (uv) items.push({ id: uv, quantity: 1 });
      });

      var drawer = document.querySelector('cart-drawer');
      var payload = { items: items };
      if (drawer && typeof drawer.renderContents === 'function') {
        payload.sections = ['cart-drawer', 'cart-icon-bubble'];
        payload.sections_url = window.location.pathname;
      }

      var label = cta.querySelector('b');
      var old = label ? label.textContent : '';
      cta.disabled = true;
      if (label) label.textContent = 'ADDING\u2026';

      function restore() {
        cta.disabled = false;
        if (label) label.textContent = old;
      }

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          restore();
          if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
            drawer.renderContents(data);
            return;
          }
          if (drawer && typeof drawer.refreshCartDrawer === 'function') {
            drawer.refreshCartDrawer().then(function () { drawer.open(); });
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:ajax-update', { detail: {} }));
          window.location.href = rootUrl() + 'cart';
        })
        .catch(function () {
          restore();
          alert('Sorry, that could not be added to your cart. Please try again.');
        });
    });
  }

  // Any link pointing at #moodie-setup scrolls smoothly to the bundle picker
  // when it exists on this page, instead of navigating away.
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href*="#' + ANCHOR + '"]') : null;
    if (!link) return;
    if (document.getElementById(ANCHOR)) {
      e.preventDefault();
      scrollToSetup();
    }
  });

  function initAll() {
    document.querySelectorAll('[data-moodie-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-moodie-hero]') : null;
    if (el) initHero(el);
  });
})();
